<template>
  <!--
      作者：gmshop
      时间：2019-10-25
      描述：云仓-云仓管理-云仓详情-添加云仓产品
  -->
  <div>
  <el-dialog title="添加" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form">
      <el-form-item label="选择用户" :label-width="formLabelWidth" v-if="!user_id">
        <el-row>
          <el-button @click="openUserDialog" icon="el-icon-plus">选择会员</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img :src="user.avatarUrl" width="100" height="100" />
            <span>ID:{{user.user_id}}</span><br>
            <span>昵称:{{user.nickName}}</span>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="选择产品" :label-width="formLabelWidth">
        <el-row>
          <el-button @click="openProduct" icon="el-icon-plus">选择产品</el-button>
          <div v-if="form.product_id!=''" class="img">
            <img :src="product.image" width="100" height="100" />
            <span>产品ID:{{product.product_id}}</span><br>
            <span>产品名称:{{product.product_name}}</span>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="产品数量"  :label-width="formLabelWidth">
        <el-input size="small" type="number" min="0" step="1" v-model="form.product_number" width="50" placeholder="请输入产品数量"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addtUser" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
  <!--用户选择-->
  <GetUser :is_open="open_user" @close="closeUserDialog"></GetUser>
  <!--商品选择-->
  <Product :isproduct="isproduct" :excludeIds="excludeIds" :islist="true" @closeDialog="closeProduct"></Product>
  </div>
</template>

<script>
  import WarehouseApi from '@/api/warehouse.js';
  import Product from '@/components/product/Product.vue';
  import GetUser from '@/components/user/GetUser.vue';
  export default {
    components: {
      Product,
      GetUser
    },
    data() {
      return {
        /*是否打开选择商品*/
        isproduct: false,
        open_user: false,
        /*产品去重*/
        excludeIds: [],
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        /*form表单数据*/
        product:{},
        user:{},
        user_id: '',
        form: {
          user_id: '',
          product_id: '',
          product_number: '',
        },
      };
    },
    props: ['open_add','model'],
    created() {
      this.excludeIds = this.model.excludeIds;
      this.user_id = this.model.user_id;
      this.dialogVisible = this.open_add;

    },
    methods: {
      /*添加*/
      addtUser() {
        let self = this;

        let params = self.form;
        // console.log(params)
        if(!params.user_id && self.user_id){
            params.user_id = self.user_id;
        }else if(!params.user_id && !self.user_id){
            this.showMessage('无用户');
            return ;
        }
        
        if(!params.product_id){
            this.showMessage('请选择产品');
            return ;
        }
        if(!params.product_number){
            this.showMessage('请输入产品数量');
            return ;
        }
        self.loading = true;
        WarehouseApi.edit(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '恭喜你，操作成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },
      showMessage(msg='信息不能为空'){
        this.$message({
            message: msg,
            type: 'warning'
          });
      },
      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*打开用户弹窗*/
    openProduct() {
      this.isproduct = true;
    },
    /*关闭用户弹窗*/
    closeProduct(e) {
      if (e.type != 'error') {
        this.product = e.params[0];
        console.log(e.params[0])
        this.form.product_id = e.params[0].product_id;
      }
      this.isproduct = false;
    },
    /*打开用户弹窗*/
    openUserDialog() {
      this.open_user = true;
    },
    /*关闭用户弹窗*/
    closeUserDialog(e) {
      if (e.type != 'error') {
        this.user = e.params[0];
        console.log(e.params[0])
        this.form.user_id = e.params[0].user_id;
      }
      this.open_user = false;
    },

    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/warehouse/warehouse/dialog/Add.vue